export * from "../completions.js";
import * as StringCompletions from "./lpc.Completions.StringCompletions.js";
export { StringCompletions };
